export default __webpack_public_path__ + "static/qm-4117d849d1eeb043cc97713d92759b22.png";